import {Component, EventEmitter, Input, OnInit, Output, OnDestroy} from '@angular/core';

@Component({
  selector: 'app-vp-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
})

export class ToolbarComponent implements OnInit, OnDestroy {
  @Input() title: string;
  @Input() isReturnable = true;
  @Input() thirdControlButtonName: string;
  @Input() secondControlButtonName: string;
  @Output() firstButtonPressedEvent = new EventEmitter<any>();
  @Output() secondButtonPressedEvent = new EventEmitter<any>();
  @Output() thirdButtonPressedEvent = new EventEmitter<any>();

  isInIframe = false;
  isMobile = false;

  constructor() {
    this.isInIframe = window.self !== window.top;
    this.checkMobile();
  }

  ngOnInit() {
    window.addEventListener('resize', () => this.checkMobile());
  }

  ngOnDestroy() {
    window.removeEventListener('resize', () => this.checkMobile());
  }

  checkMobile() {
    this.isMobile = window.innerWidth <= 480;
  }

  shouldShowWidgetCloseButton(): boolean {
    return this.isInIframe && this.isMobile;
  }

  closeWidget() {
    // Send message to parent window to close the widget
    if (this.isInIframe && window.parent) {
      window.parent.postMessage({
        type: 'chat:close'
      }, '*');
    }
  }

  onFirstButtonPressed() {
    this.firstButtonPressedEvent.emit();
  }

  onSecondButtonPressed() {
    this.secondButtonPressedEvent.emit();
  }

  onThirdButtonPressed() {
    this.thirdButtonPressedEvent.emit();
  }

}
